<template>
	<div id="ZCbuliangzichanbaoxingzhizhanbi" style="width: 100%;height:100%;" ref="ZCbuliangzichanbaoxingzhizhanbi"></div>
</template>

<script>
	import * as echarts from "echarts";
	import apis from "@/http/apis";
	import chartClickMixin from "@/views/index/components/handlemixin.js"; // 引入混合

	export default {
		name: 'ZCbuliangzichanbaoxingzhizhanbi',
		// 使用混合
		mixins: [chartClickMixin],

		// 组件传参，拿到父组件传递的数据
		props: {
			greenTraffic: {
				default () {
					return [];
				},
			},
			// 添加图表名称属性
			chartName: {
				type: String,
				default: '存量资产性质占比'
			}
		},
		data() {
			return {
				arrX: [],
				arrY: [],
				statusData: [], // 债权状态分类数据（追偿中、已结案等）
				chartType: 'bar' // 指定图表类型
			};
		},
		watch: {
			// 侦听父组件的数据，发生变化后处理数据后重新渲染dom
			greenTraffic: {
				handler(val) {
					this.arrX = [];
					this.arrY = [];
					if (Array.isArray(val) && val.length) {
						val.forEach((item) => {
							this.arrX.push(item.trafficKey);
							this.arrY.push((Number(item.trafficValue) / 10000).toFixed(2));
						});
					}
					this.drawFftjChart();
				},
				deep: true,
			},
		},
		created() {
			this.apidata();
		},
		methods: {
			// 重写混合中的初始化方法
			initChartWithClick() {
				// 这个方法的实现在drawFftjChart中
			},

			apidata() {
				Promise.all([
					apis.nonPerformingAssetType(),
					apis.nonPerformingAssetStatus()
				]).then(([typeRes, statusRes]) => {
					const typeList = typeRes && typeRes.data && typeRes.data.list ? typeRes.data.list : [];
					this.arrX = typeList.map(item => item.name === '信通资产包' ? '信通资产' : item.name);
					this.arrY = typeList.map(item => item.value);

					const statusList = statusRes && statusRes.data && statusRes.data.list ? statusRes.data.list : [];
					this.statusData = statusList;

					this.drawFftjChart();
				}).catch((err) => {
					console.error('不良资产包性质占比接口请求失败', err);
				});
			},
			drawFftjChart() {
				var chart = echarts.init(this.$refs.ZCbuliangzichanbaoxingzhizhanbi || document.getElementById("ZCbuliangzichanbaoxingzhizhanbi"));

				// 与饼图颜色保持一致
				const statusColorMap = {
					'追偿中': '#FF8C00',
					'已结案': '#14ff00',
				};
				const fallbackColors = ['#ffc700', '#ff6b6b', '#a29bfe', '#fd79a8'];

				const hasStatus = this.statusData && this.statusData.length > 0;

				let series;
				if (hasStatus) {
					// 按状态分类创建堆叠系列，与饼图保持一致
					series = this.statusData.map((status, idx) => {
						const color = statusColorMap[status.name] || fallbackColors[idx % fallbackColors.length];
						const isLast = idx === this.statusData.length - 1;
						return {
							type: 'bar',
							name: status.name,
							stack: 'total',
							barWidth: 26,
							itemStyle: { color },
							label: {
								show: isLast,
								position: 'right',
								color: '#fff',
								fontSize: 12,
								formatter: () => `${this.arrY[0] || 0}个`
							},
							data: this.arrX.map((_, i) => (i === 0 ? status.value : 0)),
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							}
						};
					});
				} else {
					// 降级：沿用原单色柱
					series = [{
						type: 'bar',
						name: this.chartName,
						barWidth: 26,
						itemStyle: {
							color: (params) => this.getColorByIndex(params.dataIndex)
						},
						label: {
							show: true,
							position: 'right',
							color: '#fff',
							fontSize: 12,
							formatter: '{c}个'
						},
						data: this.arrX.map((name, index) => ({
							name,
							value: this.arrY[index] || 0,
							itemStyle: { color: this.getColorByIndex(index) }
						})),
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}];
				}

				const tooltipFormatter = hasStatus
					? (params) => {
						if (Array.isArray(params) && params.length) {
							const lines = params
								.filter(p => p.value > 0)
								.map(p => `${p.marker}${p.seriesName}：${p.value}个`)
								.join('<br/>');
							return `${params[0].axisValue}<br/>${lines}`;
						}
						return '';
					}
					: (params) => {
						if (Array.isArray(params)) {
							return params[0].name + '：' + params[0].value + '个';
						}
						return params;
					};

				const option = {
					grid: {
						left: "2%",
						right: "2%",
						top: "5%",
						bottom: "2%",
						width: "90%",
						height: "90%",
						containLabel: true,
					},
					tooltip: {
						trigger: "axis",
						axisPointer: { type: "shadow" },
						formatter: tooltipFormatter,
					},
					xAxis: {
						type: "value",
						nameTextStyle: {
							color: "#fff",
							fontSize: 12,
						},
						axisTick: { show: false },
						axisLine: {
							show: true,
							lineStyle: { color: "rgba(255, 255, 255, 0.3)" },
						},
						axisLabel: { color: "#fff", fontSize: 12 },
						splitLine: {
							show: true,
							lineStyle: { color: "rgba(255,255,255,0.3)", type: 'dashed' },
						},
					},
					yAxis: {
						type: "category",
						data: this.arrX,
						axisTick: { show: false },
						axisLine: {
							show: true,
							lineStyle: { color: "rgba(255, 255, 255, 0.3)" },
						},
						axisLabel: {
							color: "#fff",
							fontSize: 12,
							margin: 10,
							triggerEvent: true,
							formatter: this.labelFormatter
						},
						inverse: false,
					},
					series,
				};

				chart.setOption(option);

				// 设置点击事件
				this.setupChartClick(chart, 'echarts');

				// 响应窗口大小变化
				window.addEventListener("resize", this.handleResize);
			},

			// 辅助方法：根据索引获取颜色
			getColorByIndex(index) {
				const colors = [
					// 'rgba(255, 214, 0, 1.0)',
					// 'rgba(64, 158, 255, 1.0)',
					'rgba(81, 203, 101, 1.0)',
					// 'rgba(245, 108, 108, 1.0)',
					// 'rgba(230, 162, 60, 1.0)',
					// 'rgba(144, 147, 153, 1.0)'
				];
				return colors[index % colors.length];
			},

			// 标签格式化方法
			labelFormatter(params) {
				var str = "";
				var paramsLen = params.length;
				var len = 4;
				var rowNumber = Math.ceil(paramsLen / len);

				if (paramsLen > len) {
					for (var i = 0; i < rowNumber; i++) {
						var start = i * len;
						var end = start + len;
						if (i == rowNumber - 1) {
							str += params.substring(start, paramsLen);
						} else {
							str += params.substring(start, end) + "\n";
						}
					}
				} else {
					str = params;
				}
				return str;
			}
		}
	};
</script>